import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { gAuthVerifyLoginToken, telegramAuthVerify, telegramResendOtpAuthOn } from "src/api/securityAuthApi";
import { setLogin } from "src/redux/reducers/user";
import { useAppDispatch, useAppSelector } from "src/redux/redux-hooks";
import { showErrorToast, showSuccessToast } from "src/utils/toast";
import OtpInput from "react-otp-input";
import clsx from "clsx";
import SocketInitialization from "src/SocketInitialization";
import useAutoLogoutSocket from "src/sockets/useAutoLogoutSocket";

const LoginAuth = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { name } = useParams();
  const { userData } = useAppSelector((state) => state.user);
  const { artifacts } = useAppSelector((state) => state.app);
  const [otp, setOtp] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  useAutoLogoutSocket();

  const handleLoginRes = (response: any) => {
    if (response.data) {
      if (response.token) localStorage.setItem("token", response.token);
      if (response.data) localStorage.setItem("user_data", JSON.stringify(response.data));

      dispatch(setLogin({ token: response.token, userData: response.data }));
      if (!response.data?.is_password_changed) {
        navigate("/reset-password");
      } else {
        showSuccessToast("Success");
        navigate("/market-analysis");
      }
    } else {
      showErrorToast("Something went wrong");
    }
  };

  const handleVerifyOtp = (newOtp: string) => {
    if (!userData?.user_id || loading) return;

    setLoading(true);
    telegramAuthVerify({ otp_type: "LOGIN", payload: { otp: newOtp, admin_id: userData?.user_id } })
      .then((response) => handleLoginRes(response))
      .catch((error) => {
        // const message = error?.data?.status_message ?? "Something went wrong";
        // showErrorToast(message);
        setOtp("");
      })
      .finally(() => setLoading(false));
  };

  const handleVerifyGoogleAuth = (newOtp: string) => {
    if (!userData?.user_id || loading) return;

    setLoading(true);
    gAuthVerifyLoginToken({ token: newOtp, user_id: userData?.user_id })
      .then((response) => handleLoginRes(response))
      .catch((error) => {
        // const message = error?.data?.status_message ?? "Something went wrong";
        // showErrorToast(message);
        setOtp("");
      })
      .finally(() => setLoading(false));
  };

  const onOtpChange = (newOtp: string) => {
    const nOtp = newOtp.replace(/\D/g, "");
    setOtp(nOtp);

    if (nOtp.length === 6 && name === "telegram") {
      handleVerifyOtp(nOtp);
    } else if (nOtp.length === 6 && name === "google") {
      handleVerifyGoogleAuth(nOtp);
    }
  };

  const handleResend = () => {
    if (!userData?.user_id || loading) return;

    setLoading(true);
    telegramResendOtpAuthOn({ payload: { user_id: userData?.user_id } })
      .then(() => {
        // toast.success("Sucessfully Code Generate.");
        setOtp("");
      })
      .catch((error) => {
        const message = error?.data?.status_message ?? "Something went wrong";
        showErrorToast(message);
        setOtp("");
      })
      .finally(() => setLoading(false));
  };

  if (!name) return null;

  return (
    <Fragment>
      <>
        <SocketInitialization />
        <div
          className={clsx("login-auth", {
            "loader-section-parent": loading,
          })}
        >
          {loading && <div className="loader-overlay"></div>}
          <div className="loginInner1 authentication">
            <div className="log-logo m-b-20 text-center">
              <img src={artifacts?.logo} className="logo-login" alt="logo" />
            </div>
            <div className="featured-box-login featured-box-secundary default">
              <h3 className="text-center" style={{ color: "var(--text-table-header)" }}>
                Security Code Verification Using {name === "google" ? "Google Authenticator" : "Telegram App"}
              </h3>
              <div className="mt-3 text-center">
                Enter 6-digit code from your {name === "google" ? "Google Authenticator" : "telegram bot"}{" "}
                {name !== "google" && (
                  <span style={{color:"var(--bs-blue)"}}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleResend();
                      }}
                    >
                      Resend Code
                    </a>
                  </span>
                )}
              </div>
              <form autoComplete="off" method="post" className="mt-3">
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <OtpInput
                    value={otp}
                    onChange={onOtpChange}
                    numInputs={6}
                    inputType="tel"
                    renderInput={(props, index) => {
                      return (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <input
                            min="0"
                            max="9"
                            maxLength={1}
                            pattern="[0-9]"
                            {...props}
                            style={{}}
                            className="otp-input"
                          />
                        </div>
                      );
                    }}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    </Fragment>
  );
};

export default LoginAuth;
